import React, { useState, useEffect } from "react";
import ClientLayout from "../../component/appLayouts/clientLayout/clientLayout";
import DataTableDisplay from "../../component/ListeDevis/ListeDevis";
import {
  deleteClient,
  getClients,
  updateClientStatus,
} from "../../services/user.service";
import EyeIcon from "../../component/icons/detailsIcon";
import EditIcon from "../../component/icons/edit";
import DisabledIcon from "../../component/icons/disabledIcon";
import icondeleteDevise from "../../assets/delete.png";
import "./index.scss";
import AppButton from "../../component/AppButton";
import CreateUser from "../../component/modalcreateClient";
import iconAddDevis from "../../assets/add.png";
import CreateClient from "../../component/modalcreateClient";
import EditClient from "../../component/modaleditClient";
import DevisService from "../../services/devis.service"; // Import the class
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../component/authProvider";
import iconSearch from "../../assets/Search.png";
import ResponsiveCard from "../../component/ResponsiveCards";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
function ClientsList() {
  const [clients, setClients] = useState([]); // State to store the client data
  const [loading, setLoading] = useState(true); // Loading state for the API call
  const [error, setError] = useState(null); // Error state to handle API errors
  const [currentPage, setCurrentPage] = useState(1);
  const { currentUser } = useAuth();
  const [searchQuery, setSearchQuery] = useState(""); // Add search query state

  const [perPage, setPerPage] = useState(10); // or whatever your page size is
  const [open, setOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 768; // détection simple du mobile
  const [statusFilter, setStatusFilter] = useState(""); // pour filtrer par statut
  const [roleFilter, setRoleFilter] = useState(""); // pour filtrer par rôle

  const getStatusColor = (currentStatus) => {
    switch (currentStatus) {
      case "nouveau":
        return "bg-blue";
      case "en cours":
        return "bg-orange";
      case "traité":
        return "bg-green";
      default:
        return "bg-blue";
    }
  };
  const [devisList, setDevisList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query); // Le filtrage se fait dans le useEffect
  };
  const handleDeleteClient = async (id) => {
    const confirmDelete = window.confirm(
      "Êtes-vous sûr de vouloir supprimer ce client ?"
    );

    if (confirmDelete) {
      await deleteClient(id, () => {
        setClients((prev) => prev.filter((client) => client._id !== id));
      });
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      // Appelle une API qui met à jour le status dans le backend
      const updatedClient = await updateClientStatus(id, newStatus);
      // Mets à jour le state local
      setClients((prev) =>
        prev.map((client) =>
          client._id === id ? { ...client, status: newStatus } : client
        )
      );
    } catch (error) {
      console.error("Erreur lors de la mise à jour du statut :", error);
    }
  };
  // Fetch Clients and Devis data
  const fetchClientsAndDevis = async () => {
    try {
      const res = await getClients();
      setClients(res); // Call the service to fetch clients and save them to state
    } catch (err) {
      setError("Failed to fetch clients or devis");
      console.error(err);
    } finally {
      setLoading(false); // Set loading to false after the API call finishes
    }
  };

  const fetchClients = async () => {
    try {
      const res = await getClients();
      // ✅ Trier par date de création (du plus récent au plus ancien)
      const sortedClients = res.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setClients(sortedClients);
    } catch (err) {
      setError("Failed to fetch clients");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch clients when the component mounts
    fetchClients();
    // fetchClientsAndDevis(); // Fetch clients and devis when the component mounts
  }, []);
  useEffect(() => {
    const lowerQuery = searchQuery.toLowerCase();
    const filtered = clients.filter((client) => {
      const fullName = `${client.firstname} ${client.lastname}`.toLowerCase();
      const clientRole = client.Role?.toLowerCase() || "";
      const matchesSearch =
        fullName.includes(lowerQuery) || clientRole.includes(lowerQuery);
      const matchesRole =
        roleFilter === "" || clientRole === roleFilter.toLowerCase();
      return matchesSearch && matchesRole;
    });
    setFilteredData(filtered);
  }, [searchQuery, roleFilter, clients]);

  // Show loading or error state if applicable

  if (error) {
    return <p>{error}</p>;
  }

  // Handle actions like view and delete
  const handleView = (client) => {
    console.log("View client", client);
    // Add your logic to view client details
  };

  const columns = [
    {
      name: "Nom & Prénom", // Column title
      selector: (row) => (
        <div
          onClick={() => navigate(`/viewUser/${row?._id}`)}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer", // Pour indiquer que c'est cliquable
          }}
        >
          <span
            style={{
              padding: "0 0.6rem",
            }}
          >
            {row?.firstname} {row?.lastname}
          </span>
        </div>
      ), // Render full name by using row data
    },

    {
      name: "Date Création", // Column title
      selector: (row) => (
        <span>{new Date(row?.createdAt).toLocaleDateString()}</span>
      ), // Format date if necessary
    },
    // {
    //   name: "Réference",
    //   selector: (row, index) => {
    //     const globalIndex = (currentPage - 1) * perPage + index + 1;
    //     return <span>{`N°${String(globalIndex).padStart(3, "0")}`}</span>;
    //   },
    // },
    // {
    //   name: "Services Demandes",
    //   selector: (row) => {
    //     console.log("Row data in Services Demandes:", row);

    //     return (
    //       <span>
    //         {row?.userId?.servicesDemandes?.map((service, index) => (
    //           <span key={index}>
    //             {service}
    //             {fetchClientsAndDevis(row?.userId._id)}
    //             {index < row?.userId?.servicesDemandes.length - 1 ? ", " : ""}
    //           </span>
    //         ))}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   name: "Budget", // Column title
    //   selector: (row) => (
    //     <span>{row?.budgetEstime ? `$${row?.budgetEstime}` : "N/A"}</span>
    //   ), // Format budget or display N/A if no budget
    // },

    {
      name: "Rôle ", // Column title
      selector: (row) => <span>{row?.Role ? `${row?.Role}` : "N/A"}</span>, // Format budget or display N/A if no budget
    },
    // {
    //   name: "Status",
    //   selector: (row) => (
    //     <select
    //       className={`status-select ${getStatusColor(
    //         row.status?.toLowerCase()
    //       )}`}
    //       value={row?.status || "Nouveau"}
    //       onChange={(e) => handleStatusChange(row._id, e.target.value)}
    //     >
    //       <option value="Nouveau">Nouveau</option>
    //       <option value="En cours">En cours</option>
    //       <option value="Traité">Traité</option>
    //     </select>
    //   ),
    // },

    {
      name: "Actions", // Column title for actions like View or Delete
      selector: (row) => (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          {/* Eye Button */}
          <button
            type="button"
            className=" btn-link detailsbutton p-0"
            style={{ borderRadius: "14px" }}
            onClick={() => {
              if (row && row?._id) {
                navigate(`/viewUser/${row?._id}`);
              } else {
                console.error("Row or row.id is undefined");
              }
            }}
          >
            <label className=" action-icon detailsicons" title="View Details">
              Détails
            </label>
          </button>

          <button
            style={{
              borderRadius: "6px",
              backgroundColor: "var(--primary-color)",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "none",
              padding: "0",
            }}
            onClick={() => {
              setSelectedUser(row); // ← on enregistre l'utilisateur à modifier
              setIsEditModalOpen(true); // ← on ouvre la modal
            }}
          >
            <EditIcon />
          </button>

          <button
            className="delete-devise-user"
            onClick={() => handleDeleteClient(row._id)}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "6px",
              backgroundColor: "transparent",
              border: "none",
              padding: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={icondeleteDevise}
              alt="delete"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
        </div>
      ),
    },
  ];

  return (
    <ClientLayout>
      <div id="ListClientPage" className="clients-page p-3">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">Liste des utilisateurs</h3>
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-4 ">
            <select
              className="form-select me-2 py-2 my-2"
              style={{ width: "200px" }}
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}
            >
              <option value="">Tous les rôles</option>
              <option value="admin">Admin</option>
              <option value="client">Client</option>
              <option value="gestionnaire">Gestionnaire</option>
            </select>
            <AppButton
              onClick={() => {
                setOpen(true);
              }}
            >
              {`Nouveau Utilisateur`}
              <img
                src={iconAddDevis}
                alt="add user icon"
                className="logo ms-2"
              />
            </AppButton>
          </div>
          <CreateClient show={open} handleClose={() => setOpen(false)} />
        </div>
        <div className="d-flex gap-3 align-items-center">
          <div className="search-container py-3">
            <div className="search-input-wrapper position-relative">
              <img src={iconSearch} alt="search icon" className="search-icon" />
              <input
                type="text"
                id="search-input"
                className="form-control ps-5 pe-5" // ps-5 adds left padding so the icon doesn’t overlap text
                placeholder="Rechercher ..."
                value={searchQuery} // Bind search query to input value
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="container-fluid py-5">
          <div className="col-12">
            <div className="card-body">
              {" "}
              {isMobile ? (
                <ResponsiveCard
                  data={filteredData}
                  onEdit={(user) => {
                    setSelectedUser(user);
                    setIsEditModalOpen(true);
                  }}
                  onDelete={handleDeleteClient}
                />
              ) : (
                <DataTableDisplay
                  data={filteredData}
                  columns={columns}
                  onChangePage={(page) => setCurrentPage(page)}
                  onChangeRowsPerPage={(newPerPage, page) => {
                    setPerPage(newPerPage);
                    setCurrentPage(page);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {isEditModalOpen && selectedUser && (
        <EditClient
          show={isEditModalOpen}
          handleClose={() => {
            setIsEditModalOpen(false);
            setSelectedUser(null);
          }}
          user={selectedUser}
          onUserUpdated={() => {
            fetchClients(); // rafraîchir les données
            setIsEditModalOpen(false);
            setSelectedUser(null);
          }}
        />
      )}
      <ToastContainer autoClose={3000} />
    </ClientLayout>
  );
}

export default ClientsList;
